import { Container, YStack, Paragraph, H2, H3 } from '@holo/ui';
import Image from 'next/image';
import cropPlanningMap from 'public/img/crop-planning-map.png';
import cropPlanningMapMobile from 'public/img/crop-planning-map-mobile.png';

const CropPlanningSection = () => {
  return (
    <YStack backgroundColor="$contrast" id="crop-planner">
      <Container>
        <YStack space="$8" py="$14" $sm={{ flexDirection: 'row' }} $md={{ py: '$30' }}>
          {/* Top (left on desktop) */}
          <YStack $sm={{ flex: 1, flexBasis: 0 }}>
            <H2 color="$base" fontSize="$32" $md={{ fontSize: '$40' }}>
              Crop planning that brings your fields online
            </H2>

            <H3 mt="$8" color="$base" fontSize="$14" $sm={{ fontSize: '$16' }} fontWeight="$medium" lineHeight="$2">
              Plans that are executable
            </H3>
            <Paragraph lineHeight="$2" color="$basePale" mt="$4">
              Gone are the days when crop plans were just static plans. With holo you can make your crop plans
              executable by configuring all the tasks you need from seeding, watering, to plant maintenance, and
              transplanting.
            </Paragraph>
            <YStack $md={{ flexDirection: 'row', space: '$8' }}>
              <YStack $md={{ flex: 1, flexBasis: 0 }}>
                <H3 mt="$8" $sm={{ fontSize: '$16' }} color="$base" fontSize="$14" fontWeight="$medium" lineHeight="$2">
                  Give your customers real time access to what is available in your fields
                </H3>
                <Paragraph lineHeight="$2" color="$basePale" mt="$4">
                  Since your crop plans are executable and are updated daily, they become your real time inventory of
                  what is available in your field. You field workers can easily track and update expected yields and
                  harvest times directly out in the field. Since this is directly reflected in what is available in your
                  online store, you will boost your customer trust and satisfaction with real time information on what
                  is actually growing in your fields and available for sale.
                </Paragraph>
              </YStack>
              <YStack $md={{ flex: 1, flexBasis: 0 }}>
                <H3 mt="$8" color="$base" fontSize="$14" $sm={{ fontSize: '$16' }} fontWeight="$medium" lineHeight="$2">
                  Make you crop plans available for future sale
                </H3>
                <Paragraph lineHeight="$2" color="$basePale" mt="$4">
                  Once you have your crop plan setup, you can just hit the share button and send the link to all your
                  wholesale customers so that they can see what you are planning to grow in the upcoming season. In our
                  next version, customers will also be able to request pre purchase agreements where they can specify
                  the crops, quantity and time spans that they are interested in and you can reply to their bid by
                  specifying your prices and availability.
                </Paragraph>
              </YStack>
            </YStack>
          </YStack>

          {/* Bottom (right on desktop) */}
          <YStack position="relative" justifyContent="center" $sm={{ flex: 1, flexBasis: 0 }}>
            <Image
              src={cropPlanningMap}
              alt="Crop planning map"
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
            <Image
              src={cropPlanningMapMobile}
              alt="Crop planning map mobile"
              style={{
                width: '25vw',
                minWidth: 100,
                maxWidth: 178,
                height: 'auto',
                margin: '-30% auto 0 auto',
              }}
            />
          </YStack>
        </YStack>
      </Container>
    </YStack>
  );
};

export default CropPlanningSection;
